<template>
  <div class="shopGoodsList_box">
    <div class="w">
      <el-card class="box-card shopGoodsList" v-loading="!shopInfoShow">
        <div slot="header" class="clearfix">
          <span class="font-20 flex-align-items header-title">
            <img class="w-px-45 m-r-10" style="border-radius: 50%" :src="shopInfo.shopLogo" alt="">
            {{shopInfo.shopName}}
          </span>
        </div>
        <companyProductList v-if="shopInfoShow" :supplierId="shopInfo.supplierId"></companyProductList>
      </el-card>
    </div>
  </div>
</template>

<script>
  import companyProductList from "@/components/RemoteSensingMall/companyProductList";

  export default {
    name: "shopGoodsList",
    // import引入的组件需要注入到对象中才能使用
    components: {companyProductList},
    data() {
      return {
        goodsId: '',
        shopInfo: {},
        shopInfoShow: false
      }
    },
    // 创建完成
    created() {
      this.goodsId = this.$route.query.goodsId;
      this.getSupplierInfoFn()
    },
    // 方法集合
    methods: {
      async getSupplierInfoFn() {
        try {
          let res1 = await this.$http.post(this.$const.RemoteSensingMall.IDshopGet, {
            goodsId: this.goodsId,
            userId: this.$store.state.user.userInfo.id
          });
          if (res1 && res1.data && res1.code === 200) {
            // console.log(res1);
            this.shopInfo = res1.data;
            setTimeout(() => {
              this.shopInfoShow = true;
            }, 800)
          }
        } catch (e) {
          console.log(e);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .shopGoodsList_box {
    background: #eff2f7;
    padding: 20px;

    .shopGoodsList {
      min-height: 300px;
      .header-title{
      }
    }
  }
</style>
